import styled from "styled-components"

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4rem;
    .titleSection {
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
            display: flex;
            gap: .5rem;
            align-items: center;
            h1 {
                font-size: 1.5rem;
                font-weight: 700;
            }
        }

        .buttonSection {
            display: flex;
            gap: .8rem;
        }
    }
`;

export const LinkButton = styled.button`
    display: flex;
    gap: .5rem;
    padding: .5rem;
    color: #1890FF;
    font-size: .8rem;
`;

export const Button = styled.button`
    display: flex;
    gap: .5rem;
    padding: .5rem;
    color: #FFF;
    background-color: #1890FF;
    font-size: .8rem;
    border-radius: 2px;

`;